import React from "react";
import PrimoPrezzo from '../img/PrimoPrezzo.png'

const GridEstrazioni = ({idx, data, tickets}) => {

    return (
        <div>
            <div className="accordion-item" key={data} style={{border: 'none', borderTop: '1px solid #C2D1CA', borderRadius: 0}}>
                <h2
                    className="accordion-header"
                    id={`heading${idx}`}
                >
                    <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${idx}`}
                        aria-expanded="false"
                        aria-controls={`collapse${idx}`}
                        style={{ borderTop: '' }}
                    >
                        Estrazione {data} ({tickets.length} biglietti)
                    </button>
                </h2>
                <div
                    id={`collapse${idx}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`heading${idx}`}
                    data-bs-parent="#accordionEstrazioni"
                >
                    <div className="accordion-body p-0">
                        <table className="table table-striped mb-0">
                            <thead style={{ backgroundColor: 'var(--medium-1)', color: '#fff' }}>
                                <tr>
                                    <th className="d-none d-md-block">Cassa</th>
                                    <th>Scontrino</th>
                                    <th>Data</th>
                                    <th className="d-none d-md-block">Ora</th>
                                    <th>Tot.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tickets.map((t, i) => (
                                    <tr key={i}>
                                        <td className="d-none d-md-block">{t.cassa}</td>
                                        <td>{t.numero_scontrino}</td>
                                        <td>{t.data_scontrino}</td>
                                        <td className="d-none d-md-block">{t.ora_scontrino}</td>
                                        <td>{t.totale_scontrino}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GridEstrazioni;
